module.exports = __webpack_public_path__ + "img/barcode.f4aedfc7.png";